// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Alert-module__font-s-10___nUxgU {
  font-size: 10px !important;
}

.Alert-module__font-s-12___M_EEr {
  font-size: 12px !important;
}

.Alert-module__font-s-13___i0nUL {
  font-size: 13px !important;
}

.Alert-module__font-s-14___AMkZb {
  font-size: 14px !important;
}

.Alert-module__font-s-15___ug2tF {
  font-size: 15px !important;
}

.Alert-module__font-s-16___XSWdF {
  font-size: 16px !important;
}

.Alert-module__font-s-18___YGm9R {
  font-size: 18px !important;
}

.Alert-module__font-s-20___yz57a {
  font-size: 20px !important;
}

.Alert-module__font-s-22___f1ymj {
  font-size: 22px !important;
}

.Alert-module__font-s-28___r1CsG {
  font-size: 28px !important;
}

.Alert-module__font-w-400___VuEUu {
  font-weight: 400 !important;
}

.Alert-module__font-w-500___Y98kV {
  font-weight: 500 !important;
}

.Alert-module__font-w-600___yqJOj {
  font-weight: 600 !important;
}

.Alert-module__font-w-700___Nwwod {
  font-weight: 700 !important;
}

.Alert-module__p-5___zlxVi {
  padding: 5px !important;
}

.Alert-module__p-12___FLscB {
  padding: 12px !important;
}

.Alert-module__p-16___lWqGH {
  padding: 16px !important;
}

.Alert-module__p-30___FpYDZ {
  padding: 30px !important;
}

.Alert-module__p-b-0___loCt9 {
  padding-bottom: 0 !important;
}

.Alert-module__p-b-5___LGzv3 {
  padding-bottom: 5px !important;
}

.Alert-module__p-b-10___jOhzD {
  padding-bottom: 10px !important;
}

.Alert-module__p-b-12___KLnhy {
  padding-bottom: 12px !important;
}

.Alert-module__p-b-16___nzMqn {
  padding-bottom: 16px !important;
}

.Alert-module__p-b-18___BdU1L {
  padding-bottom: 18px !important;
}

.Alert-module__p-b-20___trJx9 {
  padding-bottom: 20px !important;
}

.Alert-module__p-b-25___SBRDN {
  padding-bottom: 25px !important;
}

.Alert-module__p-b-30___BWA70 {
  padding-bottom: 30px !important;
}

.Alert-module__p-b-50___o2cpG {
  padding-bottom: 50px !important;
}

.Alert-module__p-t-0___amMNv {
  padding-top: 0 !important;
}

.Alert-module__p-t-12___Wv036 {
  padding-top: 12px !important;
}

.Alert-module__p-t-16___nMEdK {
  padding-top: 16px !important;
}

.Alert-module__p-t-18___yMZHW {
  padding-top: 18px !important;
}

.Alert-module__p-t-20___BqCKa {
  padding-top: 20px !important;
}

.Alert-module__p-t-30___RWeJF {
  padding-top: 30px !important;
}

.Alert-module__p-t-40___SbwZu {
  padding-top: 40px !important;
}

.Alert-module__p-t-50___Cloh7 {
  padding-top: 50px !important;
}

.Alert-module__p-l-20___ysL4A {
  padding-left: 20px !important;
}

.Alert-module__p-l-30___CnILG {
  padding-left: 30px !important;
}

.Alert-module__p-l-40___u0R6K {
  padding-left: 40px !important;
}

.Alert-module__p-r-16___u0IhP {
  padding-right: 16px !important;
}

.Alert-module__p-r-20___yuwrB {
  padding-right: 20px !important;
}

.Alert-module__p-r-30___GktMK {
  padding-right: 30px !important;
}

.Alert-module__p-r-50___pqBU_ {
  padding-right: 50px !important;
}

.Alert-module__p-r-60___uNGOz {
  padding-right: 60px !important;
}

.Alert-module__m-b-1___jpCBx {
  margin-bottom: 1px !important;
}

.Alert-module__m-b-2___vE05N {
  margin-bottom: 2px !important;
}

.Alert-module__m-b-6___Z8Es4 {
  margin-bottom: 6px !important;
}

.Alert-module__m-b-8___oS8uS {
  margin-bottom: 8px !important;
}

.Alert-module__m-b-10___aNEAn {
  margin-bottom: 10px !important;
}

.Alert-module__m-b-14___Qumuv {
  margin-bottom: 14px !important;
}

.Alert-module__m-b-16___F9RpC {
  margin-bottom: 16px !important;
}

.Alert-module__m-b-20___Wr7eZ {
  margin-bottom: 20px !important;
}

.Alert-module__m-b-22___IeCV9 {
  margin-bottom: 22px !important;
}

.Alert-module__m-b-24___IA9kN {
  margin-bottom: 24px !important;
}

.Alert-module__m-b-30___WLg4G {
  margin-bottom: 30px !important;
}

.Alert-module__m-b-32___rmogd {
  margin-bottom: 32px !important;
}

.Alert-module__m-b-40___Wg7YK {
  margin-bottom: 40px !important;
}

.Alert-module__m-t-2___Mkeno {
  margin-top: 2px !important;
}

.Alert-module__m-t-3___GUhjO {
  margin-top: 3px !important;
}

.Alert-module__m-t-4___nHp39 {
  margin-top: 4px !important;
}

.Alert-module__m-t-5___IG9wj {
  margin-top: 5px !important;
}

.Alert-module__m-t-8___Bkd6Y {
  margin-top: 8px !important;
}

.Alert-module__m-t-10___idKhW {
  margin-top: 10px !important;
}

.Alert-module__m-t-15___zROHK {
  margin-top: 15px !important;
}

.Alert-module__m-t-16___UTVeF {
  margin-top: 16px !important;
}

.Alert-module__m-t-20___RnvGv {
  margin-top: 20px !important;
}

.Alert-module__m-t-22___UVXzs {
  margin-top: 22px !important;
}

.Alert-module__m-t-30___Md7D5 {
  margin-top: 30px !important;
}

.Alert-module__m-t-32___Yaor0 {
  margin-top: 32px !important;
}

.Alert-module__m-l-auto___a2cG5 {
  margin-left: auto !important;
}

.Alert-module__m-l-4___ThVwP {
  margin-left: 4px !important;
}

.Alert-module__m-l-5___jYP0a {
  margin-left: 5px !important;
}

.Alert-module__m-l-6___SSwC6 {
  margin-left: 6px !important;
}

.Alert-module__m-l-8___TgaMT {
  margin-left: 8px !important;
}

.Alert-module__m-l-10___76y9g {
  margin-left: 10px !important;
}

.Alert-module__m-l-16___YtDYh {
  margin-left: 16px !important;
}

.Alert-module__m-l-20___OBFn9 {
  margin-left: 20px !important;
}

.Alert-module__m-l-24____VG8P {
  margin-left: 24px !important;
}

.Alert-module__m-l-30___KhAEQ {
  margin-left: 30px !important;
}

.Alert-module__m-l-35___O3EzE {
  margin-left: 35px !important;
}

.Alert-module__m-l-40___s2d_C {
  margin-left: 40px !important;
}

.Alert-module__m-r-8___S8COl {
  margin-right: 8px !important;
}

.Alert-module__m-r-10___mtfS2 {
  margin-right: 10px !important;
}

.Alert-module__m-r-16___eKHd8 {
  margin-right: 16px !important;
}

.Alert-module__m-r-20___clBiE {
  margin-right: 20px !important;
}

.Alert-module__m-r-24___o6b1J {
  margin-right: 24px !important;
}

.Alert-module__m-r-30___yJUBi {
  margin-right: 30px !important;
}

.Alert-module__m-r-40___J4zRg {
  margin-right: 40px !important;
}

.Alert-module__border-r-3___lI_NK {
  border-radius: 3px !important;
}

.Alert-module__border-r-4___YBzJA {
  border-radius: 4px !important;
}

.Alert-module__border-r-6___OSlMe {
  border-radius: 6px !important;
}

.Alert-module__border-r-10___ddCEX {
  border-radius: 10px !important;
}

.Alert-module__border-r-12___vA4aT {
  border-radius: 12px !important;
}

.Alert-module__border-r-16___pYrM3 {
  border-radius: 16px !important;
}

.Alert-module__border-r-50___JmBCl {
  border-radius: 50% !important;
}

.Alert-module__primary-border___R9W9M {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-b___zv1Ks {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-t___FT6am {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-l___Nk6cH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-r___u2nRo {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__secondary-border___uYpdl {
  border: 1px solid #637768;
}

.Alert-module__secondary-border-b___YRrdJ {
  border-bottom: 1px solid #637768;
}

.Alert-module__secondary-border-t___KLgbj {
  border-top: 1px solid #637768;
}

.Alert-module__secondary-border-l___Qz4Fr {
  border-left: 1px solid #637768;
}

.Alert-module__secondary-border-r___F2k1f {
  border-right: 1px solid #637768;
}

.Alert-module__gap-0___bHsZM {
  gap: 0 !important;
}

.Alert-module__gap-2___a8f7a {
  gap: 2px !important;
}

.Alert-module__gap-4___xrVXf {
  gap: 4px !important;
}

.Alert-module__gap-5___ccvIU {
  gap: 5px !important;
}

.Alert-module__gap-6___BPl1u {
  gap: 6px !important;
}

.Alert-module__gap-8___OTrPc {
  gap: 8px !important;
}

.Alert-module__gap-10___bGyiK {
  gap: 10px !important;
}

.Alert-module__gap-12___EREl4 {
  gap: 12px !important;
}

.Alert-module__gap-14___nn3Xy {
  gap: 14px !important;
}

.Alert-module__gap-16___OnQZR {
  gap: 16px !important;
}

.Alert-module__gap-18___xDNaZ {
  gap: 18px !important;
}

.Alert-module__gap-20___zU3BR {
  gap: 20px !important;
}

.Alert-module__gap-24___ZNWeY {
  gap: 24px !important;
}

.Alert-module__gap-26___aQqWN {
  gap: 26px !important;
}

.Alert-module__gap-30___E82li {
  gap: 30px !important;
}

.Alert-module__gap-32___HlDcw {
  gap: 32px !important;
}

.Alert-module__gap-40___h0Sds {
  gap: 40px !important;
}

.Alert-module__gap-50___kspPl {
  gap: 50px !important;
}

.Alert-module__flex-1___VpxcS {
  flex: 1;
}

.Alert-module__flex-none___PzLhr {
  flex: none !important;
}

.Alert-module__flex-column___n6VzR {
  display: flex;
  flex-direction: column !important;
}

.Alert-module__flex-row___ErEuw {
  display: flex;
  flex-direction: row !important;
}

.Alert-module__vertically-centered___VpCge {
  display: flex;
  align-items: center !important;
}

.Alert-module__horizontally-centered___cAa3i {
  display: flex;
  justify-content: center !important;
}

.Alert-module__horizontally-end____USC9 {
  display: flex;
  justify-content: end !important;
}

.Alert-module__vertically-start___LW9ca {
  display: flex;
  align-items: start !important;
}

.Alert-module__space-between___hAXSO {
  display: flex;
  justify-content: space-between !important;
}

.Alert-module__flex-wrap___Bhm70 {
  flex-wrap: wrap !important;
}

.Alert-module__height-100___Gjtpu {
  height: 100%;
}

.Alert-module__width-50___WgS1y {
  width: 50% !important;
}

.Alert-module__width-100___X9Rwh {
  width: 100%;
}

.Alert-module__cursor-pointer___U3erW {
  cursor: pointer;
}

.Alert-module__cursor-not-allowed___Fd2HN {
  cursor: not-allowed !important;
}

.Alert-module__absolute-centered___sGMQe {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Alert-module__absolute___ApWjI {
  position: absolute;
}

.Alert-module__relative___Nr3RD {
  position: relative;
}

.Alert-module__fixed___f6CvF {
  position: fixed;
}

.Alert-module__visible___cEv0J {
  opacity: 1;
}

.Alert-module__invisible___vFX3W {
  opacity: 0;
}

.Alert-module__col-90___gvt2Z {
  width: 90% !important;
}

.Alert-module__col-auto___EPIoe {
  width: auto !important;
}

.Alert-module__medical-tabs___raZSj {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Alert-module__medical-table-new___j06Ad {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Alert-module__medical-table-new___j06Ad:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Alert-module__medical-table-new___j06Ad::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Alert-module__medical-table-new___j06Ad::-webkit-scrollbar-track {
  display: none;
}
.Alert-module__medical-table-new___j06Ad.Alert-module__no-pagination___DQWrk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Alert-module__medical-table-new___j06Ad.Alert-module__no-pagination___DQWrk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Alert-module__medical-table-new___j06Ad.Alert-module__no-pagination___DQWrk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Alert-module__medical-table-new___j06Ad.Alert-module__no-pagination___DQWrk::-webkit-scrollbar-track {
  display: none;
}

.Alert-module__medical-table-empty___lg28J {
  padding: 14px 40px !important;
}

.Alert-module__icon-btn___IdQAy {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Alert-module__search-icon___tPR2p {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Alert-module__disable-select___FIbU_ {
  user-select: none;
}

.Alert-module__break-word___Fj3H2 {
  word-break: break-word;
}

.Alert-module__popup-clear-btn___z5Cu5 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Alert-module__scroll-m-b-20___DSNYP {
  scroll-margin-bottom: 20px;
}

.Alert-module__alert___7_QeX {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  column-gap: 10px;
  row-gap: 2px;
  width: 100%;
  padding: 10px 13px;
  border: 1px solid;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.4286;
  text-align: left;
}

.Alert-module__flush___mn78S {
  border-left-width: 0;
  border-right-width: 0;
  border-radius: 0;
}

.Alert-module__default___bGmLn {
  background: #ffffff;
  border-color: #e4e4e7;
  color: #3f3f46;
}

.Alert-module__warning___LDH5K {
  background: #fefce8;
  border-color: #fde68a;
  color: #854d0e;
}

.Alert-module__destructive___owjWz {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.Alert-module__info___LMW7e {
  background: #f0f9ff;
  border-color: #bae6fd;
  color: #0369a1;
}

.Alert-module__success___zQN3b {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}

.Alert-module__icon___ld6iM {
  flex-shrink: 0;
  margin-top: 2px;
}

.Alert-module__body___lmbw7 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.Alert-module__title___xkONr {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.375;
}

.Alert-module__description___jzT7j {
  display: flex;
  flex-direction: column;
  gap: 6px;
  line-height: 1.5;
}
.Alert-module__description___jzT7j > div {
  color: #52525b;
}

.Alert-module__inlineRow___M4Ndw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.Alert-module__inlineActions___MhPnF {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.Alert-module__actions___lfISX {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  color: #3f3f46;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Alert/Alert.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,qBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.alert {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: start;\n  column-gap: 10px;\n  row-gap: 2px;\n  width: 100%;\n  padding: 10px 13px;\n  border: 1px solid;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.4286;\n  text-align: left;\n}\n\n.flush {\n  border-left-width: 0;\n  border-right-width: 0;\n  border-radius: 0;\n}\n\n.default {\n  background: tone-color(neutral, bg);\n  border-color: tone-color(neutral, border);\n  color: tone-color(neutral, text);\n}\n\n.warning {\n  background: tone-color(warning, bg);\n  border-color: tone-color(warning, border);\n  color: tone-color(warning, text);\n}\n\n.destructive {\n  background: tone-color(danger, bg);\n  border-color: tone-color(danger, border);\n  color: tone-color(danger, text);\n}\n\n.info {\n  background: tone-color(info, bg);\n  border-color: tone-color(info, border);\n  color: tone-color(info, text);\n}\n\n.success {\n  background: tone-color(success, bg);\n  border-color: tone-color(success, border);\n  color: tone-color(success, text);\n}\n\n.icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.375;\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  line-height: 1.5;\n\n  > div {\n    color: #52525b;\n  }\n}\n\n.inlineRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-width: 0;\n}\n\n.inlineActions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 8px;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  color: #3f3f46;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Alert-module__font-s-10___nUxgU`,
	"fontS12": `Alert-module__font-s-12___M_EEr`,
	"fontS13": `Alert-module__font-s-13___i0nUL`,
	"fontS14": `Alert-module__font-s-14___AMkZb`,
	"fontS15": `Alert-module__font-s-15___ug2tF`,
	"fontS16": `Alert-module__font-s-16___XSWdF`,
	"fontS18": `Alert-module__font-s-18___YGm9R`,
	"fontS20": `Alert-module__font-s-20___yz57a`,
	"fontS22": `Alert-module__font-s-22___f1ymj`,
	"fontS28": `Alert-module__font-s-28___r1CsG`,
	"fontW400": `Alert-module__font-w-400___VuEUu`,
	"fontW500": `Alert-module__font-w-500___Y98kV`,
	"fontW600": `Alert-module__font-w-600___yqJOj`,
	"fontW700": `Alert-module__font-w-700___Nwwod`,
	"p5": `Alert-module__p-5___zlxVi`,
	"p12": `Alert-module__p-12___FLscB`,
	"p16": `Alert-module__p-16___lWqGH`,
	"p30": `Alert-module__p-30___FpYDZ`,
	"pB0": `Alert-module__p-b-0___loCt9`,
	"pB5": `Alert-module__p-b-5___LGzv3`,
	"pB10": `Alert-module__p-b-10___jOhzD`,
	"pB12": `Alert-module__p-b-12___KLnhy`,
	"pB16": `Alert-module__p-b-16___nzMqn`,
	"pB18": `Alert-module__p-b-18___BdU1L`,
	"pB20": `Alert-module__p-b-20___trJx9`,
	"pB25": `Alert-module__p-b-25___SBRDN`,
	"pB30": `Alert-module__p-b-30___BWA70`,
	"pB50": `Alert-module__p-b-50___o2cpG`,
	"pT0": `Alert-module__p-t-0___amMNv`,
	"pT12": `Alert-module__p-t-12___Wv036`,
	"pT16": `Alert-module__p-t-16___nMEdK`,
	"pT18": `Alert-module__p-t-18___yMZHW`,
	"pT20": `Alert-module__p-t-20___BqCKa`,
	"pT30": `Alert-module__p-t-30___RWeJF`,
	"pT40": `Alert-module__p-t-40___SbwZu`,
	"pT50": `Alert-module__p-t-50___Cloh7`,
	"pL20": `Alert-module__p-l-20___ysL4A`,
	"pL30": `Alert-module__p-l-30___CnILG`,
	"pL40": `Alert-module__p-l-40___u0R6K`,
	"pR16": `Alert-module__p-r-16___u0IhP`,
	"pR20": `Alert-module__p-r-20___yuwrB`,
	"pR30": `Alert-module__p-r-30___GktMK`,
	"pR50": `Alert-module__p-r-50___pqBU_`,
	"pR60": `Alert-module__p-r-60___uNGOz`,
	"mB1": `Alert-module__m-b-1___jpCBx`,
	"mB2": `Alert-module__m-b-2___vE05N`,
	"mB6": `Alert-module__m-b-6___Z8Es4`,
	"mB8": `Alert-module__m-b-8___oS8uS`,
	"mB10": `Alert-module__m-b-10___aNEAn`,
	"mB14": `Alert-module__m-b-14___Qumuv`,
	"mB16": `Alert-module__m-b-16___F9RpC`,
	"mB20": `Alert-module__m-b-20___Wr7eZ`,
	"mB22": `Alert-module__m-b-22___IeCV9`,
	"mB24": `Alert-module__m-b-24___IA9kN`,
	"mB30": `Alert-module__m-b-30___WLg4G`,
	"mB32": `Alert-module__m-b-32___rmogd`,
	"mB40": `Alert-module__m-b-40___Wg7YK`,
	"mT2": `Alert-module__m-t-2___Mkeno`,
	"mT3": `Alert-module__m-t-3___GUhjO`,
	"mT4": `Alert-module__m-t-4___nHp39`,
	"mT5": `Alert-module__m-t-5___IG9wj`,
	"mT8": `Alert-module__m-t-8___Bkd6Y`,
	"mT10": `Alert-module__m-t-10___idKhW`,
	"mT15": `Alert-module__m-t-15___zROHK`,
	"mT16": `Alert-module__m-t-16___UTVeF`,
	"mT20": `Alert-module__m-t-20___RnvGv`,
	"mT22": `Alert-module__m-t-22___UVXzs`,
	"mT30": `Alert-module__m-t-30___Md7D5`,
	"mT32": `Alert-module__m-t-32___Yaor0`,
	"mLAuto": `Alert-module__m-l-auto___a2cG5`,
	"mL4": `Alert-module__m-l-4___ThVwP`,
	"mL5": `Alert-module__m-l-5___jYP0a`,
	"mL6": `Alert-module__m-l-6___SSwC6`,
	"mL8": `Alert-module__m-l-8___TgaMT`,
	"mL10": `Alert-module__m-l-10___76y9g`,
	"mL16": `Alert-module__m-l-16___YtDYh`,
	"mL20": `Alert-module__m-l-20___OBFn9`,
	"mL24": `Alert-module__m-l-24____VG8P`,
	"mL30": `Alert-module__m-l-30___KhAEQ`,
	"mL35": `Alert-module__m-l-35___O3EzE`,
	"mL40": `Alert-module__m-l-40___s2d_C`,
	"mR8": `Alert-module__m-r-8___S8COl`,
	"mR10": `Alert-module__m-r-10___mtfS2`,
	"mR16": `Alert-module__m-r-16___eKHd8`,
	"mR20": `Alert-module__m-r-20___clBiE`,
	"mR24": `Alert-module__m-r-24___o6b1J`,
	"mR30": `Alert-module__m-r-30___yJUBi`,
	"mR40": `Alert-module__m-r-40___J4zRg`,
	"borderR3": `Alert-module__border-r-3___lI_NK`,
	"borderR4": `Alert-module__border-r-4___YBzJA`,
	"borderR6": `Alert-module__border-r-6___OSlMe`,
	"borderR10": `Alert-module__border-r-10___ddCEX`,
	"borderR12": `Alert-module__border-r-12___vA4aT`,
	"borderR16": `Alert-module__border-r-16___pYrM3`,
	"borderR50": `Alert-module__border-r-50___JmBCl`,
	"primaryBorder": `Alert-module__primary-border___R9W9M`,
	"primaryBorderB": `Alert-module__primary-border-b___zv1Ks`,
	"primaryBorderT": `Alert-module__primary-border-t___FT6am`,
	"primaryBorderL": `Alert-module__primary-border-l___Nk6cH`,
	"primaryBorderR": `Alert-module__primary-border-r___u2nRo`,
	"secondaryBorder": `Alert-module__secondary-border___uYpdl`,
	"secondaryBorderB": `Alert-module__secondary-border-b___YRrdJ`,
	"secondaryBorderT": `Alert-module__secondary-border-t___KLgbj`,
	"secondaryBorderL": `Alert-module__secondary-border-l___Qz4Fr`,
	"secondaryBorderR": `Alert-module__secondary-border-r___F2k1f`,
	"gap0": `Alert-module__gap-0___bHsZM`,
	"gap2": `Alert-module__gap-2___a8f7a`,
	"gap4": `Alert-module__gap-4___xrVXf`,
	"gap5": `Alert-module__gap-5___ccvIU`,
	"gap6": `Alert-module__gap-6___BPl1u`,
	"gap8": `Alert-module__gap-8___OTrPc`,
	"gap10": `Alert-module__gap-10___bGyiK`,
	"gap12": `Alert-module__gap-12___EREl4`,
	"gap14": `Alert-module__gap-14___nn3Xy`,
	"gap16": `Alert-module__gap-16___OnQZR`,
	"gap18": `Alert-module__gap-18___xDNaZ`,
	"gap20": `Alert-module__gap-20___zU3BR`,
	"gap24": `Alert-module__gap-24___ZNWeY`,
	"gap26": `Alert-module__gap-26___aQqWN`,
	"gap30": `Alert-module__gap-30___E82li`,
	"gap32": `Alert-module__gap-32___HlDcw`,
	"gap40": `Alert-module__gap-40___h0Sds`,
	"gap50": `Alert-module__gap-50___kspPl`,
	"flex1": `Alert-module__flex-1___VpxcS`,
	"flexNone": `Alert-module__flex-none___PzLhr`,
	"flexColumn": `Alert-module__flex-column___n6VzR`,
	"flexRow": `Alert-module__flex-row___ErEuw`,
	"verticallyCentered": `Alert-module__vertically-centered___VpCge`,
	"horizontallyCentered": `Alert-module__horizontally-centered___cAa3i`,
	"horizontallyEnd": `Alert-module__horizontally-end____USC9`,
	"verticallyStart": `Alert-module__vertically-start___LW9ca`,
	"spaceBetween": `Alert-module__space-between___hAXSO`,
	"flexWrap": `Alert-module__flex-wrap___Bhm70`,
	"height100": `Alert-module__height-100___Gjtpu`,
	"width50": `Alert-module__width-50___WgS1y`,
	"width100": `Alert-module__width-100___X9Rwh`,
	"cursorPointer": `Alert-module__cursor-pointer___U3erW`,
	"cursorNotAllowed": `Alert-module__cursor-not-allowed___Fd2HN`,
	"absoluteCentered": `Alert-module__absolute-centered___sGMQe`,
	"absolute": `Alert-module__absolute___ApWjI`,
	"relative": `Alert-module__relative___Nr3RD`,
	"fixed": `Alert-module__fixed___f6CvF`,
	"visible": `Alert-module__visible___cEv0J`,
	"invisible": `Alert-module__invisible___vFX3W`,
	"col90": `Alert-module__col-90___gvt2Z`,
	"colAuto": `Alert-module__col-auto___EPIoe`,
	"medicalTabs": `Alert-module__medical-tabs___raZSj`,
	"medicalTableNew": `Alert-module__medical-table-new___j06Ad`,
	"noPagination": `Alert-module__no-pagination___DQWrk`,
	"medicalTableEmpty": `Alert-module__medical-table-empty___lg28J`,
	"iconBtn": `Alert-module__icon-btn___IdQAy`,
	"searchIcon": `Alert-module__search-icon___tPR2p`,
	"disableSelect": `Alert-module__disable-select___FIbU_`,
	"breakWord": `Alert-module__break-word___Fj3H2`,
	"popupClearBtn": `Alert-module__popup-clear-btn___z5Cu5`,
	"scrollMB20": `Alert-module__scroll-m-b-20___DSNYP`,
	"alert": `Alert-module__alert___7_QeX`,
	"flush": `Alert-module__flush___mn78S`,
	"default": `Alert-module__default___bGmLn`,
	"warning": `Alert-module__warning___LDH5K`,
	"destructive": `Alert-module__destructive___owjWz`,
	"info": `Alert-module__info___LMW7e`,
	"success": `Alert-module__success___zQN3b`,
	"icon": `Alert-module__icon___ld6iM`,
	"body": `Alert-module__body___lmbw7`,
	"title": `Alert-module__title___xkONr`,
	"description": `Alert-module__description___jzT7j`,
	"inlineRow": `Alert-module__inlineRow___M4Ndw`,
	"inlineActions": `Alert-module__inlineActions___MhPnF`,
	"actions": `Alert-module__actions___lfISX`
};
module.exports = ___CSS_LOADER_EXPORT___;
